import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../../rest-api.service';
import { CookieService } from '../../cookie.service';

@Component({
  selector: 'app-shipping-form',
  templateUrl: './shipping-form.component.html',
  styleUrls: ['../cart-page.component.css']
})
export class ShippingFormComponent implements OnInit {
  private submitted: boolean = false;
  public shippingInfo = {
    'first_name': '',
    'last_name': '',
    'email': '',
    'line1': '',
    'line2': '',
    'city': '',
    'state': '',
    'zip_code': null,
    'subscribe': false
  };
  public isClicked: boolean = false;
  public error: string;

  constructor(private restApi: RestApiService, private cookieService: CookieService) { }

  ngOnInit() {
  }

  onSubmit() {
    this.isClicked = true;
    this.handleOrderPost();
  }

  private async handleOrderPost() {
    const cartItems = this.cookieService.getCartItems();
    const cartInfo = cartItems.map((i)=> {
      return {
        'sku': i,
        'quantity': this.cookieService.getItemQuantity(i)
      };
    });
    const order = {
      'cart_items': cartInfo,
      'shipping': this.shippingInfo
    };
    if(order.shipping.subscribe == false) {
      order.shipping.subscribe = null;
    }
    try {
      const resp = await this.restApi.postOrderRequest(order);
      this.restApi.raiseOrderNumber(resp);
    } catch(err) {
      console.error(err);
      if (err.error == 'Couldn\'t get the customer') {
        this.error = 'Could not create order; make sure email address is valid.';
      }
      else if (err.error == 'Problem creating AvaTax transaction') {
        this.error = 'Could not create order; please make sure shipping address is valid.'
      }
      else {
        this.error = 'Could not create order, please try again later or contact the artist via the contact form.';
      }
      this.isClicked = false;
    }
  }

  get isCartValid() {
    return this.cookieService.getCartNumberItems() > 0;
  }

  public toggleSubscribe() {
    this.shippingInfo.subscribe = !this.shippingInfo.subscribe;
  }

}
